/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { SkeletonText } from './SkeletonText';

const Skeletons = {
  SkeletonText,
};

export { Skeletons };